import Vue from "vue";
import Vuex from "vuex";

import {
	deleteMCQquestion,
	deleteTestQuesData,
	deleteMatchTheFollowingQuestion,
	getQuestions,
} from "../../utils/apiFunctions.js";

import store from "../index.js";

Vue.use(Vuex);
const state = () => ({
	questionData: [],
	moveSelectedQuestions: [],
});

const getters = {
	getQuestionData: (state) => state.questionData,
	getMoveSelectedQuestions: (state) => state.moveSelectedQuestions,
};

const actions = {
	async getQuestions(state, payload) {
		try {
			let data = { testID: payload.testID, sectionID: payload.sectionID };
			const res = await getQuestions(data);
			if (res.status == 200) {
				payload = res.data.data.questionsBody;
				state.commit("saveAllQuestionData", payload);
			} else {
				payload = [];
				state.commit("saveAllQuestionData", payload);
			}
			return res;
		} catch (error) {
			payload = [];
			state.commit("saveAllQuestionData", payload);
			return error;
		}
	},

	// DELETE MCQ QUESTION DATA
	async deleteMCQquestion({ commit }, payload) {
		let data = {
			sectionID: payload.sectionID,
			testID: payload.testID,
			questionKey: payload.questionKey,
			marks: payload.marks,
			addToDatabank: false,
		};
		try {
			const response = await deleteMCQquestion(data);
			if (response.status == 200) {
				commit("deleteMCQquestion", payload);
			}
			return response;
		} catch (error) {
			throw new Error(`Delete MCq Failed! status: ${error.status}`);
		}
	},

	// delete ftom test only
	async deleteTestQuesData(state, payload) {
		try {
			const response = await deleteTestQuesData(payload);
			if (response.status == 200) {
				state.commit("deleteMCQquestion", payload);
			}
			return response;
		} catch (error) {
			return error;
		}
	},

	// DELETE MTF QUESTION DATA
	async deleteMatchTheFollowingQuestion({ commit }, payload) {
		let data = {
			sectionID: payload.sectionID,
			testID: payload.testID,
			questionKey: payload.questionKey,
		};
		try {
			const response = await deleteMatchTheFollowingQuestion(data);
			if (response.status == 200) {
				commit("deleteMatchTheFollowingQuestion", payload);
			}
			return response;
		} catch (error) {
			throw new Error(`Delete MAFo Failed! status: ${error.status}`);
		}
	},
};

// mutations
const mutations = {
	saveQuestionData(state, payload) {
		state.questionData.push(payload);
		for (let i in store.state.sectionVUEX.sectionDetails) {
			if (
				store.state.sectionVUEX.sectionDetails[i].sectionID ==
				store.state.sectionVUEX.selectedSection.sectionID
			) {
				store.state.sectionVUEX.sectionDetails[i].questions.push(
					payload.questionKey
				);
				store.state.sectionVUEX.sectionDetails[i].secMarks =
					parseInt(store.state.sectionVUEX.sectionDetails[i].secMarks) +
					parseInt(payload.marks);
				store.state.sectionVUEX.sectionDetails[i].numberOfQuestions =
					parseInt(
						store.state.sectionVUEX.sectionDetails[i].numberOfQuestions
					) + 1;
				let index = store.state.sectionVUEX.sectionDetails[
					i
				].typeOfQuestions.findIndex(
					(i) => i === payload.questionKey.slice(0, 4)
				);
				if (index == -1) {
					store.state.sectionVUEX.sectionDetails[i].typeOfQuestions.push(
						payload.questionKey.slice(0, 4)
					);
				}
			}
		}
	},
	saveAllQuestionData(state, payload) {
		state.questionData = payload;
		for (let qd in state.questionData) {
			for (let i in state.questionData[qd].config) {
				if (
					state.questionData[qd].config[i].SectionID ==
					store.state.sectionVUEX.selectedSection.sectionID
				) {
					state.questionData[qd].required =
						state.questionData[qd].config[i].config.required;
					state.questionData[qd].autoCorrection =
						state.questionData[qd].config[i].config.autoCorrection;
				}
			}
		}
	},

	deleteMCQquestion(state, payload) {
		let some = true;
		state.questionData = state.questionData.filter(
			(data) => data.questionKey != payload.questionKey
		);
		for (let i in store.state.sectionVUEX.sectionDetails) {
			if (
				store.state.sectionVUEX.sectionDetails[i].sectionID ==
				store.state.sectionVUEX.selectedSection.sectionID
			) {
				let index = store.state.sectionVUEX.sectionDetails[
					i
				].questions.findIndex((i) => i === payload.questionKey);
				if (index > -1) {
					store.state.sectionVUEX.sectionDetails[i].questions.splice(index, 1);
				}
				store.state.sectionVUEX.sectionDetails[i].secMarks =
					parseInt(store.state.sectionVUEX.sectionDetails[i].secMarks) -
					parseInt(payload.marks);
				store.state.sectionVUEX.sectionDetails[i].numberOfQuestions =
					parseInt(
						store.state.sectionVUEX.sectionDetails[i].numberOfQuestions
					) - 1;
				store.state.sectionVUEX.sectionDetails[i].typeOfQuestions = [];
				let index1 = store.state.sectionVUEX.sectionDetails[
					i
				].questions.findIndex((i) => i.slice(0, 4) === "MCQU");
				let index2 = store.state.sectionVUEX.sectionDetails[
					i
				].questions.findIndex((i) => i.slice(0, 4) === "MAFO");
				if (index1 > -1) {
					store.state.sectionVUEX.sectionDetails[i].typeOfQuestions.push(
						"MCQU"
					);
				}
				if (index2 > -1) {
					store.state.sectionVUEX.sectionDetails[i].typeOfQuestions.push(
						"MAFO"
					);
				}
			}
		}
		return some;
	},
	saveMoveSelectedQuestions(state, payload) {
		state.moveSelectedQuestions = payload;
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
